module.exports = __webpack_public_path__ + "img/cz.62bd9c62.svg";